<style>
  @import url("https://app.flymenu.fr/delhaize/styles.css");

  .delhaize-button {
    background-color: #f4f4f4;
    width: 5rem;
    height: 5rem;
    padding: 0.5rem;
    border: none;
    border-radius: 0.75rem;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #flymenuDelhaizeWebApp.modal-wrapper {
    position: fixed !important;
    z-index: 99999;
  }
</style>

<template></template>

<script>
  import { defineComponent, onMounted, computed, toRefs } from "@vue/composition-api";
  import { useRecipeStore } from "@/stores/recipe";
  import { storeToRefs } from "pinia";
  import Recipe2Basket, { Language, ButtonType } from "@smartwithfood/js-sdk";

  export default defineComponent({
    props: {
      amounts: Array,
      recipe: Object,
    },

    data() {
      return {
        clearButtons: null,
        translatedRecipeTitle: null,
        translatedRecipeIngredients: null,
      };
    },

    setup(props) {
      const store = useRecipeStore();

      const { amount, possibleAmounts } = storeToRefs(store);
      const { setPossibleAmounts } = store;

      onMounted(() => {
        let recaptchaScript = document.createElement("script");
        recaptchaScript.setAttribute("src", "https://app.flymenu.fr/delhaize/delhaize-webapp.js");
        document.head.appendChild(recaptchaScript);

        if (props.amounts) {
          setPossibleAmounts(props.amounts);

          if (possibleAmounts.value.find((p) => p === 2)) {
            amount.value = 2;
          } else {
            amount.value = possibleAmounts.value[0];
          }
        }
      });

      const currentIndex = computed(() => {
        return possibleAmounts.value.indexOf(amount.value);
      });

      const prevPossible = computed(() => {
        return currentIndex.value > 0;
      });

      const nextPossible = computed(() => {
        return currentIndex.value < possibleAmounts.value.length - 1;
      });

      const prevAmount = () => {
        amount.value = possibleAmounts.value[currentIndex.value - 1];
      };

      const nextAmount = () => {
        amount.value = possibleAmounts.value[currentIndex.value + 1];
      };

      return {
        amount,
        prevAmount,
        nextAmount,
        prevPossible,
        nextPossible,
      };
    },

    methods: {
      openDelhaizeBasket() {
        const ingredients = this.translatedRecipeIngredients
          ? this.translatedRecipeIngredients.map((i) => {
              return { text: i };
            })
          : this.recipe.openRecipe.ingredients.map((i) => {
              return { text: i[Object.keys(i)[0]].amounts[this.indexForIngredientWithSameAmount].unit };
            });

        const recipeData = [
          {
            name: this.translatedRecipeTitle ? this.translatedRecipeTitle : this.recipe.title,
            nb_pers: this.amount.toString(),
            ingredients: ingredients,
          },
        ];

        var exampleRecipeData = [
          {
            name: "Cake au chocolat",
            nb_pers: "4",
            ingredients: [
              { name: "Farine", qty: "200", unit: "g" },
              { name: "Oeuf", qty: "2", unit: "" },
              { name: "Beurre", qty: "100", unit: "g" },
              { name: "Chocolat", qty: "200", unit: "g" },
            ],
          },
        ];

        delhaizeweb.showRecipe(recipeData, document.documentElement.lang);
      },

      parseIngredient(ingredientString) {
        // Regular expressions for common units and numbers
        const unitRegex = /^(g|ml|cl|dl|l|kg|st|el|tl|gr|oz)$/i;
        const numberRegex = /\d+(,\d+)?/;

        // Split the string into words
        const words = ingredientString.split(" ");

        // Initialize ingredient object
        const ingredient = {
          name: "",
          qty: "",
          unit: "",
        };

        // Iterate over words to extract information
        for (let i = 0; i < words.length; i++) {
          const word = words[i];
          let isWord = true;

          // Check for quantity and unit
          const unitMatch = word.match(unitRegex);
          if (unitMatch) {
            ingredient.unit = word.toLowerCase();
            isWord = false;
            continue;
          }

          const numberMatch = word.match(numberRegex);
          if (numberMatch) {
            ingredient.qty = parseFloat(numberMatch[0]).toString();
            isWord = false;
            continue;
          }

          // Append word to ingredient name
          if (isWord) {
            ingredient.name += (i > 0 ? " " : "") + word;
          }
        }

        ingredient.name = ingredient.name.trim();
        ingredient.name = ingredient.name.charAt(0).toUpperCase() + ingredient.name.slice(1);
        ingredient.name = ingredient.name.replace(/,/g, "");

        // replace qty with empty string if is "0"
        if (ingredient.qty === "0") {
          ingredient.qty = "";
        }

        return ingredient;
      },
    },

    computed: {
      indexForIngredientWithSameAmount() {
        if (!this.recipe || !this.recipe.openRecipe) {
          return -1;
        }
        const ingredients = this.recipe.openRecipe.ingredients.map((i) => i[Object.keys(i)[0]]);
        const firstIngredientAmounts = ingredients[0].amounts;
        return firstIngredientAmounts.findIndex((a) => a.amount === this.amount);
      },

      downloadLink() {
        function getMobileOperatingSystem() {
            var userAgent = navigator.userAgent || navigator.vendor || window.opera;

            if (/android/i.test(userAgent)) {
                return "Android";
            }

            // iOS detection
            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                return "iOS";
            }

            return "unknown";
        }

        var os = getMobileOperatingSystem();

        if (os === "Android") {
            return "https://play.google.com/store/apps/details?id=com.purepascale&hl=nl"
        } else if (os === "iOS") {
            return "https://apps.apple.com/be/app/pascale-naessens/id1476365000?l=nl"
        } else {
            return "/app"
        }
      },
    },

    watch: {
      indexForIngredientWithSameAmount: {
        // get the translated recipe title and ingredients
        immediate: true,
        handler(value) {
          const self = this;
          if (document.documentElement.lang !== "nl" && this.recipe && this.recipe.openRecipe && value >= 0 && self.translatedRecipeTitle === null) {
            // translate this.recipe using Weglot
            let words = [{ t: 1, w: this.recipe.title }].concat(
              this.recipe.openRecipe.ingredients.map((i) => {
                return { t: 1, w: i[Object.keys(i)[0]].amounts[value].unit };
              }),
            );

            Weglot.translate(
              {
                words: words,
                languageTo: document.documentElement.lang,
              },
              function (data) {
                self.translatedRecipeTitle = data[0];
                self.translatedRecipeIngredients = data.slice(1);
              },
            );
          }
        },
      },
      amount(amount) {
        if (this.recipe && amount) {
          const r2b = Recipe2Basket;

          if (this.clearButtons) {
            this.clearButtons();
          }

          r2b.initialize({
            token: process.env.MIX_SMARTWITHFOOD_WIDGET_TOKEN,
            language: Language.NL,
          });

          this.clearButtons = r2b.renderButtons({
            type: ButtonType.SINGLE_RECIPE,
            selectorOrElement: ".r2b-button-container",
            recipes: [
              {
                name: this.recipe.title,
                language: Language.NL,
                media: this.recipe.media && this.recipe.media.length ? this.recipe.media[0].url : null,
                yield: amount,
                ingredients: this.recipe.openRecipe.ingredients.map((i) => i[Object.keys(i)[0]].amounts[this.indexForIngredientWithSameAmount].unit),
              },
            ],
          });
        }
      },
    },
  });
</script>
